"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _usePrevious = require("b2b-components/hooks/usePrevious");
var _Gallery = require("b2b-components/theme/components/Gallery");
var _Item = require("../Item");
var _ItemVideo = require("../ItemVideo");
const VideoItem = _ref => {
  let {
    isAutoplay,
    itemIndex,
    title,
    video,
    registerVideoStopObject,
    setIsAutoplayDirty,
    className,
    isCurrent,
    isPreview,
    onClick,
    totalItemCount,
    href,
    imageDisclaimer
  } = _ref;
  const prevIsAutoplay = (0, _usePrevious.usePrevious)(isAutoplay);
  if (isAutoplay) {
    setIsAutoplayDirty(true);
  }
  return /*#__PURE__*/_react.default.createElement(_Item.Item, {
    className: className,
    isCurrent: isCurrent,
    isPreview: isPreview,
    onClick: onClick,
    totalItemCount: totalItemCount,
    href: href,
    type: _Gallery.GALLERY_ITEM_TYPE.video,
    imageDisclaimer: imageDisclaimer
  }, /*#__PURE__*/_react.default.createElement(_ItemVideo.ItemVideo, {
    isAutoplay: prevIsAutoplay || false,
    itemIndex: itemIndex,
    registerVideoStopObject: registerVideoStopObject,
    title: title,
    video: video
  }));
};
exports.VideoItem = VideoItem;
//# sourceMappingURL=VideoItem.js.map